import React from 'react';
import PropTypes from 'prop-types';
import { createMuiTheme, MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Grid from '@material-ui/core/Grid';

const styles = {
  root: {
    width: 500,
    textAlign: 'center'
  },
};

// const defaultTheme = createMuiTheme();
const theme = createMuiTheme({
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: "1.5rem",
        color: "#ffffff",
        backgroundColor: "grey",
        marginRight: "-2rem",
        transitionDelay: '1s'
      }
    }
  }
});

function MuiToolTip(props) {
  const { classes, children } = props;
  return (
    <MuiThemeProvider theme={theme}>
      <div className={classes.root}>
        <MuiThemeProvider theme={theme}>
          <Tooltip
            title="Click link if you want to view or change a previously submitted response"
            placement="right"
          >
          {children}
          </Tooltip>
        </MuiThemeProvider>
      </div>
    </MuiThemeProvider>
  );
}

MuiToolTip.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MuiToolTip);





// WEBPACK FOOTER //
// ./src/components/popups/MuiToolTip.js